import { useEffect, useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';

import { fetchToken } from './utils';

interface UseToken {
  token: string;
  hasError: boolean;
  errorCode: string;
}

export const useToken = (isReverification = false): UseToken => {
  const request = useRequest();
  const [token, setToken] = useState('');
  const [hasError, setError] = useState(false);
  const [errorCode, setErrorCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!token && !isLoading && !hasError) {
      setIsLoading(true);
      fetchToken(request, isReverification).subscribe(
        ({ body }) => {
          setToken(body.token);
          setIsLoading(false);
        },
        (error) => {
          setErrorCode(error?.body?.globalErrors?.[0]?.code);
          setError(true);
          setIsLoading(false);
        }
      );
    }
  }, [request, setError, setToken, isReverification, isLoading, token, hasError]);

  return { token, hasError, errorCode };
};
